export default __webpack_public_path__ + "static/media/avatar-star.a2d2c6ad.svg";